import React, { useState } from "react";
import DashboardLayout from "@/components/DashboardLayout";
import { useAuth } from "@/lib/auth";
import { api } from "@/lib/api";
import { toast } from "sonner";
import { RoleBadge } from "@/components/Badges";

export default function Settings() {
  const { user, setUser } = useAuth();
  const [form, setForm] = useState({
    full_name: user?.full_name || "",
    phone: user?.phone || "",
    business_name: user?.business_name || "",
    avatar_url: user?.avatar_url || "",
  });

  const save = async (e) => {
    e.preventDefault();
    try {
      const { data } = await api.patch("/auth/me", form);
      setUser(data);
      toast.success("Profile updated");
    } catch (e) { toast.error("Failed"); }
  };

  return (
    <DashboardLayout title="Settings" subtitle="Profile, business info, and account.">
      <div className="grid lg:grid-cols-3 gap-4 max-w-5xl">
        <form onSubmit={save} className="v-card lg:col-span-2 space-y-3">
          <h3 className="font-display text-lg font-semibold text-primary">Profile</h3>
          <Field label="Full name" v={form.full_name} on={(v) => setForm({...form, full_name: v})} testid="settings-name" />
          <Field label="Business name" v={form.business_name} on={(v) => setForm({...form, business_name: v})} testid="settings-business" />
          <Field label="Phone" v={form.phone} on={(v) => setForm({...form, phone: v})} testid="settings-phone" />
          <Field label="Avatar URL" v={form.avatar_url} on={(v) => setForm({...form, avatar_url: v})} testid="settings-avatar" />
          <button className="v-btn-primary" data-testid="settings-save">Save changes</button>
        </form>
        <div className="v-card">
          <h3 className="font-display text-lg font-semibold text-primary">Account</h3>
          <div className="mt-4 space-y-3 text-sm">
            <Row label="Email" value={user?.email} mono />
            <Row label="User ID" value={user?.id?.slice(0, 12)} mono />
            <div>
              <div className="label-eyebrow mb-2">Roles</div>
              <div className="flex flex-wrap gap-1">{(user?.roles || []).map((r) => <RoleBadge key={r} role={r} />)}</div>
            </div>
          </div>
        </div>
      </div>
    </DashboardLayout>
  );
}

function Field({ label, v, on, testid }) {
  return (
    <div>
      <label className="label-eyebrow mb-2 block">{label}</label>
      <input className="v-input" value={v} onChange={(e) => on(e.target.value)} data-testid={testid} />
    </div>
  );
}
function Row({ label, value, mono }) {
  return <div><div className="label-eyebrow mb-1">{label}</div><div className={mono ? "font-mono text-sm" : "text-sm"}>{value}</div></div>;
}
